import MinorElectricalWorksForm from './MinorElectricalWorksForm';
import MinorElectricalWorksPDF from './MinorElectricalWorksPDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF, buildVerificationPayload } from './transform';

export default {
  Form: MinorElectricalWorksForm,
  PDF: MinorElectricalWorksPDF,
  schema,
  validator,
  defaultData,
  transform: transformForPDF,
  buildVerificationPayload
};